import { getCookie } from "cookies-next";
export default function getReferralType(): string {
  let referrerValue;
  const referalTypes = {
    googleadservices: "Google Paid",
    doubleclick: "Google Paid",
    gclid: "Google Paid",
    uds: "Google Paid",
    afs: "Google Paid",
    aclk: "Google Paid",
    googlesyndication: "Google Paid",
    "utm_source=google": "Google Paid",
    "utm_source=yahoo": "Yahoo Paid",
    "utm_source=bing": "Bing Paid",
    "utm_source=facebook": "Facebook Paid",
    "utm_source=creatio": "Creatio",
    "utm_source=mailchimp": "Mailchimp",
    "utm_source=instagram": "Instagram Paid",
    "utm_source=tiktok": "Tiktok Paid",
    "utm_source=x": "X Paid",
    "utm_source=reddit": "Reddit Paid",
    "utm_source=youtube": "YouTube",
    "youtube.com": "YouTube",
    "www.google": "Google Organic",
    "bing.com": "Bing Organic",
    "yahoo.com": "Yahoo Organic",
    "aol.com": "AOL Organic",
    "ask.com": "Ask Organic",
    "facebook.com": "Facebook",
    "pinterest.com": "Pinterest",
    "instagram.com": "Instagram",
    "tiktok.com": "TikTok",
    "x.com": "X",
    "reddit.com": "Reddit",
    "tripadvisor.com": "Trip Advisor",
    "vacationscostarica.com": "Direct",
    "vacations2costarica.com": "Vac2",
    "dev.crvxi.com": "Dev",
    "staging.crvxi.com": "Dev ",
    "crvxi.com": "crvxi",
  };
  const cookie = getCookie("roasurl");
  if (cookie)
    for (const key in referalTypes) {
      if (Object.hasOwnProperty.call(referalTypes, key)) {
        // @ts-expect-error
        if (cookie.indexOf(key) !== -1) {
          // @ts-expect-error
          referrerValue = referalTypes[key];
          break;
        }
      }
    }
  if (!referrerValue) {
    //  @ts-expect-error
    referrerValue = new URL(getCookie("roasurl")).hostname;
  }
  return referrerValue;
}
